import * as React from "react";

import { cn } from "./utils";
import { useReadOnlyFields } from "./read-only-fields";

function Textarea({ className, disabled, ...props }: React.ComponentProps<"textarea">) {
  const readOnlyFields = useReadOnlyFields();
  return (
    <textarea
      data-slot="textarea"
      disabled={disabled || readOnlyFields}
      className={cn(
        "resize-none border-input placeholder:text-muted-foreground focus-visible:border-ring focus-visible:ring-ring/50 aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive dark:bg-input/30 flex field-sizing-content min-h-16 w-full rounded-md border bg-input-background px-3 py-2 text-base transition-[color,box-shadow] outline-none focus-visible:ring-[3px] disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
        className,
      )}
      {...props}
    />
  );
}

export { Textarea };
